import { Routes } from '@angular/router';
import {
  LOGIN_ROUTES,
  ACTIVAR_ROUTES,
  RECUPERAR_ROUTES,
  CAMBIAR_CLAVE_ROUTES,
} from '@nebula/login';
import { LayoutComponent, RUTAS_EN_CONSTRUCCION } from '@nebula-layout/layout';
import { authGuard, loginGuard } from '@nebula-shared/data-access';
import { productoDeLaRutaGuard } from '@nebula/products';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => Promise.resolve(LOGIN_ROUTES),
    canActivate: [loginGuard],
  },
  {
    // Página pública de activación de usuario (enlace cifrado del correo, sin guard).
    path: 'activar-usuario',
    loadChildren: () => Promise.resolve(ACTIVAR_ROUTES),
  },
  {
    // Página pública de recuperación de contraseña ("olvidé mi clave", sin guard).
    path: 'recuperar',
    loadChildren: () => Promise.resolve(RECUPERAR_ROUTES),
  },
  {
    // Cambio de contraseña vencida (usuario autenticado; guard propio impide acceso directo).
    path: 'cambiar-clave',
    loadChildren: () => Promise.resolve(CAMBIAR_CLAVE_ROUTES),
  },
  {
    path: 'layout',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'accounting', pathMatch: 'full' },

      {
        path: 'company',
        loadChildren: () => import('@nebula/company').then((m) => m.COMPANY_ROUTES),
        data: {
          showSidebar: false,
          showHeader: false,
          showBreadcrumb: false,
        },
      },
      {
        path: 'products',
        loadChildren: () => import('@nebula/products').then((m) => m.PRODUCTS_ROUTES),
        data: {
          showSidebar: false,
          showHeader: false,
          showBreadcrumb: false,
        },
      },
      {
        path: 'accounting',
        canActivate: [productoDeLaRutaGuard],
        loadChildren: () => import('@nebula/accounting').then((m) => m.ACCOUNTING_ROUTES),
        data: {
          showSidebar: true,
          showHeader: true,
          showBreadcrumb: true,
        },
      },
      {
        path: 'tesorería',
        canActivate: [productoDeLaRutaGuard],
        loadChildren: () => import('@nebula/tesoreria').then((m) => m.TESORERIA_ROUTES),
        data: {
          showSidebar: true,
          showHeader: true,
          showBreadcrumb: true,
        },
      },
      {
        path: 'budget',
        canActivate: [productoDeLaRutaGuard],
        loadChildren: () => import('@nebula/budget').then((m) => m.BUDGET_ROUTES),
        data: {
          showSidebar: true,
          showHeader: true,
          showBreadcrumb: true,
        },
      },

      {
        path: 'maestros',
        canActivate: [productoDeLaRutaGuard],
        loadChildren: () => import('@nebula/maestros').then((m) => m.MAESTROS_ROUTES),
        data: {
          showSidebar: true,
          showHeader: true,
          showBreadcrumb: true,
        },
      },

      {
        path: 'vault',
        canActivate: [productoDeLaRutaGuard],
        loadChildren: () => import('@nebula/vault').then((m) => m.VAULT_ROUTES),
        data: {
          showSidebar: true,
          showHeader: true,
          showBreadcrumb: true,
        },
      },

      {
        path: 'invoicing',
        canActivate: [productoDeLaRutaGuard],
        loadChildren: () => import('@nebula/invoicing').then((m) => m.INVOICING_ROUTES),
        data: {
          showSidebar: true,
          showHeader: true,
          showBreadcrumb: true,
        },
      },

      // Productos de la fase 2 en construccion (pedido de gerencia, 29-oct-2026)
      ...RUTAS_EN_CONSTRUCCION,
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
